import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../services/api';
import { projectKeys } from './useProjects';
import type { Lavoro, CreateLavoroInput, UpdateLavoroInput } from '../types';

export function useCreateLavoro() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateLavoroInput) =>
      api.post<Lavoro>('/lavori', data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: projectKeys.detail(variables.projectId),
      });
    },
  });
}

export function useUpdateLavoro() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: {
      id: string;
      projectId: string;
      data: UpdateLavoroInput;
    }) => api.patch<Lavoro>(`/lavori/${variables.id}`, variables.data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: projectKeys.detail(variables.projectId),
      });
    },
  });
}

/** L'ordine dell'array `ids` diventa l'ordine delle lavorazioni. */
export function useReorderLavori() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: { projectId: string; ids: string[] }) =>
      api.patch<Lavoro[]>('/lavori/reorder', variables),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: projectKeys.detail(variables.projectId),
      });
    },
  });
}

export function useDeleteLavoro() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }: { id: string; projectId: string }) =>
      api.delete(`/lavori/${id}`),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: projectKeys.detail(variables.projectId),
      });
    },
  });
}
